import React, { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { unsubscribe } from '../utils/accountApi';
import useSEO from '../hooks/useSEO';

// Every marketing email links here as /unsubscribe?token=… . It works without signing in and
// acts on arrival: one click from the email is the whole job. The page never says whether the
// token matched anything, because the API deliberately does not reveal that either.

export default function UnsubscribePage() {
  const [params] = useSearchParams();
  const token = params.get('token') || '';
  const [state, setState] = useState(token ? 'working' : 'missing'); // working | done | failed | missing

  useSEO({ title: 'Unsubscribe', description: 'Stop Mama Africa marketing emails.' });

  useEffect(() => {
    if (!token) return;
    let cancelled = false;
    unsubscribe(token)
      .then(() => { if (!cancelled) setState('done'); })
      .catch(() => { if (!cancelled) setState('failed'); });
    return () => { cancelled = true; };
  }, [token]);

  const copy = {
    working: ['One moment…', 'Removing you from our mailing list.'],
    done: ['You are unsubscribed', 'You will not receive any more Mama Africa marketing emails. Thank you for the time you spent with us — Akwaaba, whenever you return.'],
    failed: ['That did not go through', 'Please try the link again in a moment, or email Mamaafricaafia@gmail.com and we will remove you by hand.'],
    missing: ['This link is incomplete', 'Please use the unsubscribe link at the bottom of one of our emails. If you have an account, you can also switch emails off on your account page.'],
  }[state];

  return (
    <div className="page-wrapper" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '70vh', padding: '40px 16px' }}>
      <div style={{ maxWidth: 480, textAlign: 'center' }}>
        <p style={{ fontFamily: "'Cinzel', serif", fontSize: 11, letterSpacing: '0.22em', color: '#C9A558', textTransform: 'uppercase', marginBottom: 12 }}>
          Email preferences
        </p>
        <h1 style={{ fontFamily: "'Playfair Display', serif", fontSize: 'clamp(28px,5vw,38px)', color: '#EDD9BC', margin: '0 0 14px' }}>{copy[0]}</h1>
        <p style={{ color: '#BA9D7C', fontSize: 17, lineHeight: 1.7, margin: '0 0 28px' }} role="status">{copy[1]}</p>
        <Link to="/" className="btn-gold" style={{ display: 'inline-block', width: 'auto', padding: '12px 28px', textDecoration: 'none' }}>
          Back to Mama Africa
        </Link>
      </div>
    </div>
  );
}
